<script>
  import { onMount } from "svelte";

  import { Card, Button } from "../../components/ui";
  import { Image, Modal } from "../../components/display";
  //   import { websiteCreate } from "../../helper/PostHelper";
  //   import { get__store } from "../../helper/FunctionHelper";
  //   import { currentProduct } from "../../stores/product";

  import { getWebsites } from "../../helper/GetHelper";
  import { navigateTo } from "svelte-router-spa";

  import WebsiteCreate from "../../edit/Website_Create.svelte";

  let editMode = false;
  let websites = null;
  export let currentRoute;

  const edit = async function(website) {
    navigateTo(
      `product/${currentRoute.namedParams.id}/edit/website/${website.id}`
    );
  };

  const save = async function(data) {
    edit(data.detail);
    // website = await websiteCreate(data.detail)
    editMode = false;
  };

  const create = async function(data) {
    editMode = true;
  };

  onMount(async() => {
    websites = await getWebsites(currentRoute.namedParams.id);
    console.log(websites);
    console.log(websites.length);
  });
</script>

<Button on:submit={create}>Create Website</Button>
{#if websites != null}
  {#if websites.length > 0}
    {#each websites as website}
      <Card class="p-4">
        {website.data.name}
        <Button
          on:submit={() => {
            edit(website);
          }}>
          Edit
        </Button>
      </Card>
    {/each}
  {/if}
{/if}

{#if editMode}
  <Modal style="max-width:42em" class="p-6">
    <div class="p-6">
      <WebsiteCreate
        productId={currentRoute.namedParams.id}
        on:save={data => {
          save(data);
        }}
        on:cancel={() => {
          editMode = false;
        }} />
    </div>

  </Modal>
{/if}
